import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {animated, useTransition} from '@react-spring/web';
import {SlideIndicator as StyledSlideIndicator} from './SlideIndicator.css';

const defaultProps = {
    initialSlide: 0,
    maxScale: 4,
    minScale: 1,
    slideIndicatorTimeout: 5000,
    activeDotColor: '#4e99e9',
    dotColor: '#dadbdc',
};

const AnimatedSlideIndicator: any = animated(StyledSlideIndicator);

export function SlideIndicator({
    currentSlide,
    inFront = true,
    slideIndicatorTimeout = 5000,
    totalSlides,
    onScreen,
}: any) {
    const [isVisible, setVisible] = useState(true);

    // Show on interaction (slide change) and when scrolled into view; only
    // start the fade-out once the slider is actually on screen, and restart it
    // on every interaction. Inactivity -> slow fade.
    useEffect(() => {
        if (slideIndicatorTimeout === null) {
            return;
        }
        setVisible(true);
        if (!onScreen) {
            return;
        }
        const timer = setTimeout(() => setVisible(false), slideIndicatorTimeout);
        return () => clearTimeout(timer);
    }, [currentSlide, onScreen, slideIndicatorTimeout]);

    const transitions = useTransition(isVisible, {
        from: {opacity: 1},
        enter: {opacity: 1},
        leave: {opacity: 0},
    });


    if (totalSlides < 2) {
        return null;
    }

    return (
        <>
            {transitions(
                (style: any, item: any, key: any, props: any) =>
                    item && (
                        <AnimatedSlideIndicator key={key} style={style}>
                            {currentSlide + 1}/{totalSlides}
                        </AnimatedSlideIndicator>
                    )
            )}
        </>
    );
}

SlideIndicator.propTypes = {
    currentSlide: PropTypes.number.isRequired,
    inFront: PropTypes.bool,
    slideIndicatorTimeout: PropTypes.number,
    totalSlides: PropTypes.number.isRequired,
};

SlideIndicator.defaultProps = {
    inFront: true,
    slideIndicatorTimeout: defaultProps.slideIndicatorTimeout,
};
